import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { Observable, map } from "rxjs";
import { PermissionLoaderService } from "../shared/services/permission-loader.service";
import { SessionService } from "../shared/services/session.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService {
  constructor(
    private sessionService: SessionService,
    private permissionLoaderService: PermissionLoaderService,
    private router: Router
  ) {}

  /**
   * Determines whether the route can be activated, once the permissions stored in the session are
   * up to date (on the first navigation after the site is loaded), so that the guards of the routes
   * below rely on them.
   * @return Emits true if the route can be activated, or a UrlTree to redirect to otherwise
   */
  canActivate(): Observable<boolean | UrlTree> {
    // The login is checked once loaded, since the session may have ended while loading the permissions
    return this.permissionLoaderService.loadPermissions().pipe(map(() => this.checkLogin()));
  }

  /**
   * Checks whether the user is currently logged in.
   * @return True if the user is logged in, or a UrlTree redirecting to /login otherwise
   */
  checkLogin(): boolean | UrlTree {
    if (this.sessionService.isLoggedIn) {
      return true;
    } else {
      return this.router.createUrlTree(["/login"]);
    }
  }
}

export const AuthGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  return inject(AuthGuardService).canActivate();
};
